<template>
  <div class="login">
    <div class="container">
      <img src="../../assets/logo.png">
      <div class="input-container" v-show="!signup">
        <input v-model="form.username" class="large" @keydown.enter="login" placeholder="帳號" type="text" />
        <input v-model="form.password" class="large" @keydown.enter="login" placeholder="密碼" type="password" />
      </div>
      <div class="input-container" v-show="signup">
        <div>邮箱</div>
        <input v-model="signForm.email" class="large" @keydown.enter="login" placeholder="邮箱" type="text" />
        <div>用户名</div>
        <input v-model="signForm.username" class="large" @keydown.enter="login" placeholder="用户名" type="text" />
        <div>密碼</div>
        <input v-model="signForm.password" class="large" @keydown.enter="login" placeholder="密碼" type="password" />
        <div>确认密码</div>
        <input v-model="signForm.password2" class="large" @keydown.enter="login" placeholder="确认密码" type="password" />
      </div>
      <div class="btn-group" v-show="!signup">
        <LoadingButton :buttonText="'申请注册'" @button-click="signup = true"></LoadingButton>
        <LoadingButton :buttonText="'登录'" :loading="loading" @button-click="login"></LoadingButton>
      </div>
      <div class="btn-group" v-show="signup">
        <LoadingButton :buttonText="'返回登录'" :loading="loading" @button-click="signup = false"></LoadingButton>
        <LoadingButton :buttonText="'注册'" @button-click="register()"></LoadingButton>
      </div>

    </div>
  </div>
</template>

<script>
import { login, register } from '@/_api/login.js'
import { setToken } from '@/utils/getToken.js'
import { Message } from 'element-ui'
import axios from 'axios'
import {validateEmail} from '@/utils/validation.js'

export default {
  data() {
    return {
      // book: {
      //   cover: require('../../assets/logo.png'),
      //   href: ''
      // },
      form: {

      },
      signup: false,
      loading: false,
      signForm: {
      }
    }
  },
  methods: {
    register() {
      if (this.signForm.password !== this.signForm.password2) {
        Message.error("确认密码错误")
        return
      }
      if (!validateEmail(this.signForm.email)) {
        Message.error("邮箱格式错误")
        return
      }
      if (this.signForm.username && this.signForm.password && this.signForm.password2 && this.signForm.email) {
        const formData = new FormData();
        formData.append('email', this.signForm.email);
        formData.append('username', this.signForm.username);
        formData.append('password', this.signForm.password);
        formData.append('gender', 'MALE');

        // const headers = {
        //   'Organizationid': 2
        // };

        const config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        };

        axios.post('http://m15652314175.oicp.net:45449/full-geek/reader/auth/register-application', formData, config)
          .then(response => {
            console.log(response.data);
            if (response.data.code == 1000) {
              Message.success("您的申请已提交，等待审核")
              this.signForm = {}
              this.signup = false
            }
            if (response.data.code == 1005) {
              Message.error("该邮箱已被注册")
            }
          })
          .catch(error => {
            console.error('注册请求错误：', error);
            Message.error(`注册失败`)
          });
      } else {
        Message.error("输入内容不完整")
      }
    },
    login() {
      if (this.loading) return
      this.loading = true
      login(this.form).then((res) => {
        console.log(res)
        if (res.status == 'ok') {
          setToken('Authorization', 'Bearer ' + res.data.token)
          localStorage.setItem('token', 'Bearer ' + res.data.token);
          this.$store.dispatch('user/updateUserInfo', {
            userId: res.data.userId,
            username: res.data.username,
            avatar: res.data.avatar,
          });
          this.$router.push('/')
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="less">
.login {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background: var(--background-color1);

  img {
    width: 120px;
  }

  .container {
    display: flex;
    gap: 40px;
    flex-direction: column;
    align-items: center;
    border-radius: 6px;
    background-color: rgba(255, 255, 255, 0.4);
    width: 30%;
    padding: 40px 80px;
    min-width: 300px;
    color: var(--text-color);
  }

  .input-container {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 10px;

    input {
      text-align: center;
      height: 42px;

      @media screen and (max-width:1180px) {
        width: 200px;
        font-size: 12px;
      }
    }

  }

  .m-button {
    font-size: 14px;
    letter-spacing: 3px;
    color: white !important;
  }
}

.btn-group {
  display: flex;
  gap: 20px;
}
</style>